import { render, staticRenderFns } from "./task_messaging.vue?vue&type=template&id=9a64e274&scoped=true"
import script from "./task_messaging.vue?vue&type=script&lang=js"
export * from "./task_messaging.vue?vue&type=script&lang=js"
import style0 from "./task_messaging.vue?vue&type=style&index=0&id=9a64e274&prod&lang=css"
import style1 from "./task_messaging.vue?vue&type=style&index=1&id=9a64e274&prod&scoped=true&lang=css"
import style2 from "./task_messaging.vue?vue&type=style&index=2&id=9a64e274&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a64e274",
  null
  
)

export default component.exports